/**
 * Holds high level configuration
 */

export const SITE_NAME_MCO = 'My Community Online';

export const SITE_NAME_POL = 'Parishes Online';

export const LISTING_TYPE_SPONSOR = 'supporter';

export const LISTING_TYPE_ORGANIZATION = 'organization';

export const BASE_PATH_ORGANIZATIONS = 'organizations';

export const BASE_PATH_SPONSORS = 'sponsors';

export const DFLIP_CSS_SRC = '/dflip/css/dflip.min.1731279540.css';

// The bundled default renderer fixes missing transparency masks in PDF patterns.
// Match DFlip's browser fallback and keep the preloaded API and worker on the same version.
export const PDFJS_VERSION = 'at' in Array.prototype ? 'default' : 'stable';

const PDFJS_BASE_PATH = PDFJS_VERSION === 'stable' ? '/dflip/js/libs/pdfjs/stable' : '/dflip/js/libs';

export const PDFJS_SCRIPT_SRC_LIST = [
    `${PDFJS_BASE_PATH}/pdf.worker.min.js`,
    `${PDFJS_BASE_PATH}/pdf.min.js`,
];

export const DFLIP_SCRIPT_SRC_LIST = [
    ...PDFJS_SCRIPT_SRC_LIST,
    '/dflip/js/libs/three.min.js',
    '/dflip/js/libs/jquery.min.js',
    '/dflip/js/dflip.min.js',
];

export const MS_24_HOURS = 24 * 60 * 60 * 1000; // 24 hours
